import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { TbCheck } from 'react-icons/tb';
import { HiXMark } from 'react-icons/hi2';
import { getOrderColorByStatusId } from '../../../Utils/Constants/Order';
import { formatCartId } from '../../../Utils/Formatters';
import { useTranslation } from 'react-i18next';

interface BoxContentQRCodeOrderProps {
    code: number;
    show: boolean;
    showCodeInline?: boolean;
    validated?: boolean;
    ring?: boolean;
    sizeCode?: number;
    sizeCheck?: number;
    canceled?: boolean;
    order_status?: number;
    className?: string;
    hideQRCode?: boolean;
}

const BoxContentQRCodeOrder = ({
    code,
    show,
    showCodeInline = true,
    validated,
    ring = true,
    sizeCode = 160,
    sizeCheck = 110,
    canceled = false,
    order_status,
    className,
    hideQRCode = false
}: BoxContentQRCodeOrderProps) => {

const { t } = useTranslation();
if (!show) return null;

return (
    <div className={`animate-fade-in
            ${ring ? 'ring-8 p-3 mb-4 rounded-lg shadow-lg shadow-black/50' : ''}
            ${validated
                ? 'ring-black bg-white'
                : `${order_status ? `ring-shopfood-${getOrderColorByStatusId(Number(order_status))}` : 'ring-shopfood-success'}`}
            ${className}
        `}>
        {!hideQRCode &&
            <div className='flex justify-center items-center relative'>
                <QRCodeCanvas size={sizeCode} bgColor='transparent' value={code.toString()} />
                {(canceled || validated) &&
                    <div className='absolute rounded-full bg-white flex items-center justify-center text-black'>
                        {!canceled && validated && <TbCheck size={sizeCheck} className='text-shopfood-success bg-white ring-8 ring-white/30 rounded-full animate-fade-in' />}
                        {canceled && <HiXMark size={sizeCheck} className='bg-white ring-8 ring-white/30 rounded-full animate-fade-in' />}
                    </div>
                }
            </div>
        }
        {showCodeInline && <div className={`flex items-center gap-2 mt-2.5 ${hideQRCode ? 'flex-col justify-center' : 'justify-between'}`}>
            <span className="font-medium text-base text-gray-400 leading-none">{t('layout.order_label')} nº</span>
            <span className={`${hideQRCode ? 'text-6xl pt-2' : 'text-3xl'} font-black text-shopfood-title leading-none tracking-tight -ml-1`}>{ formatCartId(code) }</span>
        </div>}
    </div>
  )
}

export default BoxContentQRCodeOrder;